import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx } from "@emotion/react";
import styled from "@emotion/styled";
import Typography from "@material-ui/core/Typography";

const Root = styled.div({
  height: "100vh",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

export default function FourOhFour() {
  return (
    <Root>
      <Typography variant="h1">Page Not Found</Typography>
    </Root>
  );
}
